import { ReactNode } from 'react';

import {
  OptionsWithExtraProps,
  ProviderContext,
  useSnackbar,
  VariantType,
} from 'notistack';

import { pseudoUnique } from '@cast/utils';

import { IconButton } from '../buttons';
import * as Icons from '../icons';

let useSnackbarRef: ProviderContext;
export const SnackbarUtilsConfigurator = () => {
  // eslint-disable-next-line react-hooks/globals
  useSnackbarRef = useSnackbar();
  return null;
};

export const notify = {
  success(message: ReactNode, options?: OptionsWithExtraProps<VariantType>) {
    this.notification(message, {
      variant: 'success',
      ...options,
    });
  },
  warning(message: ReactNode, options?: OptionsWithExtraProps<VariantType>) {
    this.notification(message, {
      variant: 'warning',
      ...options,
    });
  },
  info(message: ReactNode, options?: OptionsWithExtraProps<VariantType>) {
    this.notification(message, {
      variant: 'info',
      ...options,
    });
  },
  error(message: ReactNode, options?: OptionsWithExtraProps<VariantType>) {
    this.notification(message, {
      variant: 'error',
      ...options,
    });
  },
  notification(
    message: ReactNode,
    options: OptionsWithExtraProps<VariantType> = {
      variant: 'info',
    }
  ) {
    const key =
      options.key ?? (typeof message === 'string' ? message : pseudoUnique());
    useSnackbarRef.enqueueSnackbar(message, {
      preventDuplicate: true,
      autoHideDuration: 3200,
      key,
      style: { whiteSpace: 'pre-line' },
      action: (
        <IconButton
          size="sm"
          color="inherit"
          onClick={() => useSnackbarRef.closeSnackbar(key)}
        >
          <Icons.X strokeWidth="1.5" />
        </IconButton>
      ),
      ...options,
    });
  },
};
